import styled from '@emotion/styled';

const ListContainer = styled('div')`
  width: 500px;
  margin-top: 0;
  clear: both;
  position: relative;
  vertical-align: top;
  padding-right: 30px;
  padding-bottom: 30px;

  @media screen and (max-width: 480px) {
    width: 100%;
    padding-right: 0;
  }
`;

const ListItemWrapper = styled('div')`
  padding: 11px 5px;
  position: relative;
  border-top: 1px solid #d4d4d4;
`;

const ListItemFlexWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
`;

const LiFlexWrapper = styled('li')`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 3px 0 3px 15px;
  border-bottom: 1px dotted #d4d4d4;
`;

const ListItemFlexColumn = styled('div')`
  flex-grow: 1;
  flex-basis: 0;
`;

const ListItemFlexColumnNum = styled(ListItemFlexColumn)`
  text-align: right;
`;

const InnerListWrapper = styled('ul')`
  margin-top: 6px;
  list-style: none;
  padding-left: 0;
`;

export {
  ListContainer,
  ListItemWrapper,
  ListItemFlexWrapper,
  LiFlexWrapper,
  ListItemFlexColumn,
  ListItemFlexColumnNum,
  InnerListWrapper
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/transactions/styled/base_components.jsx